// The user portal's primary is the accent the admin chose. style.css keys it on
// <html data-accent="teal"> (or "teal-hc"), so everything drawn in primary,
// teleported layers included, follows one attribute. Nothing in the admin portal
// sets it, so its primary stays the brand red.
//
// Three things set it, each filling a gap the one before left. The server marks
// the shell it serves (web.ShellForAccent). Before mounting, main-user.ts fills
// in the browser's saved copy where the shell carried none: the native app's
// shell is bundled and never passes through the server. Then the theme query
// writes each answer it gets, and a pending or failed request writes nothing.
import { ACCENT_THEMES, type AccentTheme } from "@/pinia/theme";

import type { Theme } from "@/api/portal";

const DEFAULT_ACCENT: AccentTheme = "grape";

function accentKey(theme: Pick<Theme, "Accent" | "HighAccessibility"> | null | undefined): string {
  const accent = ACCENT_THEMES.find((name) => name === theme?.Accent) ?? DEFAULT_ACCENT;
  return theme?.HighAccessibility ? `${accent}-hc` : accent;
}

export function applyAccent(theme: Pick<Theme, "Accent" | "HighAccessibility">): void {
  document.documentElement.dataset.accent = accentKey(theme);
}

// Keeps what the server put on the shell, which is newer than any saved copy.
export function ensureAccent(saved: Theme | null): void {
  if (document.documentElement.dataset.accent) return;
  document.documentElement.dataset.accent = accentKey(saved);
}
